import {PriorityIcon} from '@priority-software/priority-style-react';
import React from 'react';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {IconWithTooltip} from '../../../_legacy/FormHeader/components/Menus/TopMenu';

interface Props {
    isDisabled: boolean;
    onOpen(): void;
}

const RTEIcon = ({onOpen, isDisabled}: Props) => (
    <IconWithTooltip
        componentClasses="note-icon"
        skin="standart"
        disabled={isDisabled}
        icon={PriorityIcon.AddComment}
        tooltip={getLocalizedText(texts.AddRemarksHover)}
        onClick={onOpen}
    />
);

export default RTEIcon;
